
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-20684.002 -23679 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M-20677.504-23665v-5.5h-5.5a1 1 0 0 1 0-2h5.5v-5.5a1 1 0 1 1 2 0v5.5h5.5a1 1 0 0 1 0 2h-5.5v5.5a1 1 0 1 1-2 0z","data-name":"Union 37","fill":"#fff","opacity":".87"}})])
          )
        }
      }
    